import api from './api';

// ==================== Types ====================

export interface PinStatus {
  hasPin: boolean;
  setAt: string | null;
}

export interface PinVerifyResponse {
  valid: boolean;
}

// ==================== API ====================

export const securityPinApi = {
  /**
   * Get PIN status for current user
   */
  getStatus: async (): Promise<PinStatus> => {
    const response = await api.get('/security-pin/status');
    return response.data.data;
  },

  /**
   * Setup initial security PIN
   */
  setupPin: async (pin: string): Promise<{ message: string }> => {
    const response = await api.post('/security-pin/setup', { pin });
    return response.data;
  },

  /**
   * Change existing security PIN
   */
  changePin: async (currentPin: string, newPin: string): Promise<{ message: string }> => {
    const response = await api.put('/security-pin/change', { currentPin, newPin });
    return response.data;
  },

  /**
   * Verify security PIN
   */
  verifyPin: async (pin: string): Promise<PinVerifyResponse> => {
    const response = await api.post('/security-pin/verify', { pin });
    return response.data.data;
  },

  // ==================== Admin APIs ====================

  /**
   * Admin: Get PIN status for an employee
   */
  adminGetStatus: async (userId: string): Promise<PinStatus> => {
    const response = await api.get(`/security-pin/admin/status/${userId}`);
    return response.data.data;
  },

  /**
   * Admin: Reset PIN for an employee
   */
  adminResetPin: async (userId: string, newPin: string): Promise<{ message: string }> => {
    const response = await api.put(`/security-pin/admin/reset/${userId}`, { newPin });
    return response.data;
  },

  /**
   * Admin: Remove PIN for an employee
   */
  adminRemovePin: async (userId: string): Promise<{ message: string }> => {
    const response = await api.delete(`/security-pin/admin/remove/${userId}`);
    return response.data;
  },
};

export default securityPinApi;
